<template>
  <el-select
    v-model="localValue"
    :size="size"
    :multiple="multiple"
    remote
    clearable
    :filterable="filterable"
    reserve-keyword
    :placeholder="placeholder"
    :remote-method="remoteMethod"
    @visible-change="$event ? remoteMethod() : null"
    :loading="loading"
  >
<!--    <div-->
<!--      v-loading="loading"-->
<!--      v-infinite-scroll="nextPage"-->
<!--      :infinite-scroll-immediate="false"-->
<!--      :infinite-scroll-delay="100"-->
<!--    >-->
      <el-option
        v-for="item in options"
        :key="item"
        :label="item"
        :value="item"
      >
      </el-option>
<!--    </div>-->
  </el-select>

</template>

<script>


import {paginator} from "@/mixins/paginator";

export default {
  name: "user-unique-prop-values-select",
  mixins: [paginator],
  components: {},
  props: {
    value: {},
    size: {type: String, default: ''},
    placeholder: {type: String, default: ''},
    multiple: {type: Boolean, default: false},
    filterable: {type: Boolean, default: false},

    prop: {type: String, required: true},
    meta: {type: Boolean, default: false},
  },

  data() {
    return {
      loading: false,
      query: null,
      page: 1,
      options: [],
    }
  },
  mounted() {
    // this.remoteMethod()
  },
  watch: {},
  computed: {
    localValue: {
      get: function () {
        return this.value
      },
      set: function (newValue) {
        this.selected(newValue)
      }
    }
  },
  methods: {
    remoteMethod(query) {
      this.query = query;
      // this.page = 1;
      this.options = [];
      this.getData();
    },

    nextPage(){
      this.page++;
      this.getData();
    },

    getData() {
      // if( this.paginator.pageCount && this.page > this.paginator.pageCount ){
      //   return;
      // }
      this.loading = true;
      this.$api.user.searchUniqueUsersPropValues({
        search: this.query,
        is_meta: this.meta ? 1 : null,
        prop: this.prop,
      })
        .then(data => {
          // this.options = this.options.concat(data.users);
          this.options = data.values;
          // this.paginatorFill(paginator);
        })
        .finally(() => {
          this.loading = false;
        })
    },

    selected(value) {
      this.$emit('input', value);
      this.$emit('selected', value)
    }
  },

}
</script>


<style scoped>

</style>